// @flow

import type { State } from "@store/reducers";
import type { AbsenceReason } from "@modules/shared/reducer/absence-reasons/types";

export const getAbsenceReasons = (state: State): Array<AbsenceReason> => {
  return state.shared.absenceReasons.options.absenceReasons;
};

export const getAbsenceReasonsLabels = (
  state: State,
  absenceReasonIdList: Array<number>,
): string => {
  const absenceReasons = getAbsenceReasons(state);
  return absenceReasonIdList
    .reduce((acc, absenceReasonId) => {
      const existingAbsenceReason = absenceReasons.find(
        absenceReason => absenceReason.id === absenceReasonId,
      );

      if (existingAbsenceReason) {
        return [...acc, existingAbsenceReason.label];
      }

      return acc;
    }, [])
    .join(", ");
};
